
import Github from "../../../assets/filled/Github.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GithubIcon({ className, dataTestid = "GithubIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Github data-testid={dataTestid} className={classes} {...rest} />
  );
}
